module.exports = __webpack_public_path__ + "img/skull.faf95f1f.svg";